import {makeAutoObservable} from "mobx";
import {api} from "../../api";
import {ReceiptListItemDto, ReceiptTypeDto} from "../../api/kpi";
import {ChartDataItemReceiptType, KpiShippingLoadParams, sortedReceiptTypes} from "./commons";

class KpiReceiptStore {
    get recordChartData(): ChartDataItemReceiptType[] {
        return this._recordChartData;
    }

    set recordChartData(value: ChartDataItemReceiptType[]) {
        this._recordChartData = value;
    }
    get documentChartData(): ChartDataItemReceiptType[] {
        return this._documentChartData;
    }

    set documentChartData(value: ChartDataItemReceiptType[]) {
        this._documentChartData = value;
    }
    get recordData(): ReceiptListItemDto[] {
        return this._recordData;
    }

    set recordData(value: ReceiptListItemDto[]) {
        this._recordData = value;
    }
    get documentData(): ReceiptListItemDto[] {
        return this._documentData;
    }

    set documentData(value: ReceiptListItemDto[]) {
        this._documentData = value;
    }

    get availableTypes(): ReceiptTypeDto[] {
        return this._availableTypes;
    }

    private set availableTypes(value: ReceiptTypeDto[]) {
        this._availableTypes = value;
    }

    private _documentChartData: ChartDataItemReceiptType[] = []
    private _recordChartData: ChartDataItemReceiptType[] = []
    private _availableTypes: ReceiptTypeDto[] = []
    private _documentData: ReceiptListItemDto[] = []
    private _recordData: ReceiptListItemDto[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async loadReceipts(query: KpiShippingLoadParams) {
        try {
            const documentTypes:ReceiptTypeDto[] = [ReceiptTypeDto.PLACEMENT_COMPLETE, ReceiptTypeDto.ACQUISITION_COMPLETE, ReceiptTypeDto.SCAN_COMPLETE]
            const recordTypes:ReceiptTypeDto[] = [ReceiptTypeDto.ACQUISITION_RECORD_COMPLETE, ReceiptTypeDto.PLACEMENT_RECORD_COMPLETE, ReceiptTypeDto.SCAN_RECORD_COMPLETE]

            const result = await api.kpi.api.listReceipts(query)
            const items = result.data.items
            this.documentData = items.filter(e => documentTypes.indexOf(e.receiptType) !== -1)
            this.recordData = items.filter(e => recordTypes.indexOf(e.receiptType) !== -1)
        } catch (ignored) {
            //TODO: mark as error
            this.documentData = []
            this.recordData = []
        }
        this.documentChartData = this.buildChartData(this.documentData)
        this.recordChartData = this.buildChartData(this.recordData)

    }

    private buildChartData(data: ReceiptListItemDto[]) {
        this.availableTypes = sortedReceiptTypes

        const groupedByDate: Record<string, ChartDataItemReceiptType> = {};

        data.forEach(({date, receiptType, count}) => {
            if (!groupedByDate[date]) {
                groupedByDate[date] = {
                    date
                };
            }
            groupedByDate[date][receiptType] = count;
        });

        return Object.values(groupedByDate)
            .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
            .map(a => {

                return {...a, date: (new Date(a.date)).toLocaleDateString('de')}
            })
    }
}

const kpiReceiptStore = new KpiReceiptStore()

export {
    kpiReceiptStore
}
